import { atom, useAtom } from 'jotai';

const turnaroundSupplier = atom<{
  id: string;
  label: string;
  name: string;
} | null>(null);

export const useTurnaroundSupplier = () => useAtom(turnaroundSupplier);
